<template>
  <div  class="dropdown is-hoverable is-right">
    <div v-if="gApiReady && googleLogged && googleEmail" class="dropdown-trigger">
      <button aria-haspopup="true" :class="gApiReady && googleLogged ? 'is-googleAgenda' : 'is-brand'" aria-controls="dropdown-menu" class="page-header-btn is-small page-header-btn--separetedIco-right is-small">
        <span class="is-padding-right-small is-small">
          <i class="fab fa-google"></i>
        </span>
        <span v-if="gApiReady && googleLogged && googleEmail">
          {{googleEmail}}
        </span>
        <span class="icon is-small" aria-haspopup="true" aria-controls="dropdown-menu">
          <i class="fas fa-ellipsis-v"></i>
        </span>
      </button>
    </div>
    <div v-if="gApiReady && googleLogged && googleEmail" class="dropdown-menu" id="dropdown-menu" role="menu">
      <div class="dropdown-content has-text-left">
        <div v-if="gApiReady && !googleLogged" class="dropdown-item">
          <a @click="googleLogin">
            <span class="icon is-small"><i class="fab fa-google"></i></span>
            <span>Connexion Google</span>
          </a>
        </div>
        <div v-if="gApiReady && googleLogged" class="dropdown-item">
          <a @click="openGoogleSyncModal">
            <span class="icon"><i class="fas fa-cloud-download"></i></span>
            <span>Importer rendez-vous</span>
          </a>
        </div>
        <div v-if="gApiReady && googleLogged" class="dropdown-item">
          <a @click="googleLogout">
            <span class="icon"><i class="fas fa-sign-out"></i></span>
            <span>Se Déconnecter</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { bus, EVENTS } from '../../services/bus/index.js'

  export default {
    name: 'GoogleSyncButton',
    data () {
      return {
        calendarGoogleSyncModalActive: false
      }
    },
    computed: {
      ...mapState(['gApiReady', 'googleLogged']),
      ...mapGetters(['googleEmail'])
    },
    methods: {
      googleLogin () {
        window.gapi.auth2.getAuthInstance().signIn().then(res => {
          // this.openGoogleSyncModal()
        })
      },
      googleLogout () {
        window.gapi.auth2.getAuthInstance().signOut()
      },
      openGoogleSyncModal () {
        this.$store.commit('setQuickview', {mode: 'GOOGLE_EVENT_SELECTION'})
      }
    },
    mounted () {
      if (!this.gApiReady) bus.$emit(EVENTS.INIT_GOOGLE_API)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/calendar/GoogleSyncButton.vue